import { create } from 'zustand';

// Translation cache: { [languageId]: { [pageId]: { [textCode]: translatedText } } }
type TranslationCache = { [languageId: number]: { [pageId: number]: { [textCode: string]: string } } };

interface LanguageStore {
  selectedLanguage: number;
  setSelectedLanguage: (languageId: number) => void;
  languages: { id: number; name: string }[];
  // Translation cache (all languages)
  translationCache: TranslationCache;
  translationCacheKey: string; // "addressSystemId" (no longer includes languageId)
  setTranslationCache: (cache: TranslationCache, cacheKey: string) => void;
  clearTranslationCache: () => void;
  isTranslationsLoaded: boolean;
  isTranslationsLoading: boolean; // Prevents race conditions
  setIsTranslationsLoaded: (loaded: boolean) => void;
  setIsTranslationsLoading: (loading: boolean) => void;
}

const useLanguageStore = create<LanguageStore>((set) => ({
  selectedLanguage: 2, // Default: English (localStorage overrides if set)
  setSelectedLanguage: (languageId: number) => {
    set({ selectedLanguage: languageId });
    // Persist to localStorage
    localStorage.setItem('selectedLanguage', languageId.toString());
    // NOTE: No longer clearing cache on language change - all languages are pre-loaded!
  },
  languages: [
    { id: 1, name: 'Suomi' },
    { id: 2, name: 'Englanti' },
    { id: 3, name: 'Ruotsi' },
    // { id: 4, name: 'UAE' },
    // { id: 5, name: 'Puola' },
    // { id: 6, name: 'Tanska' },
  ],
  // Translation cache (all languages)
  translationCache: {},
  translationCacheKey: '',
  setTranslationCache: (cache: TranslationCache, cacheKey: string) => set({ translationCache: cache, translationCacheKey: cacheKey, isTranslationsLoaded: true, isTranslationsLoading: false }),
  clearTranslationCache: () => set({ translationCache: {}, translationCacheKey: '', isTranslationsLoaded: false, isTranslationsLoading: false }),
  isTranslationsLoaded: false,
  isTranslationsLoading: false,
  setIsTranslationsLoaded: (loaded: boolean) => set({ isTranslationsLoaded: loaded }),
  setIsTranslationsLoading: (loading: boolean) => set({ isTranslationsLoading: loading }),
}));

// Initialize from localStorage on app start
const initializeLanguage = () => {
  const saved = localStorage.getItem('selectedLanguage');
  if (saved) {
    useLanguageStore.setState({ selectedLanguage: parseInt(saved) });
  }
};

initializeLanguage();

export default useLanguageStore;